export default __webpack_public_path__ + "static/media/email-bl-icon.ccc88ec8.svg";